import { render, staticRenderFns } from "./TrajetPatient.vue?vue&type=template&id=98e1dc7e"
import script from "./TrajetPatient.vue?vue&type=script&lang=js"
export * from "./TrajetPatient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports